import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation, Mousewheel } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { toggleVideoVisible, updateUserActivity, updateUserActivityVideo } from "../../../../redux/slices/userActivity";
import { toggleConfirmReplaceModal, updateMasterToReplace, updateMegaSlider } from "../../../../redux/slices/sidebarSliders";

//clicking on any theme from trending themes will open the theme in the design box
export default function Slider({ data, header, toggleExtensionCollapse, activityTypeId, subtypeId, isLoadMoreVisible, activityTypeName, subtypeName }) {
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const dispatch = useDispatch();
  const { userActivities, selectedUserActivity, videoVisible, isVideo, } = useSelector((state) => state.userActivity);
// console.log('sliderdata', data);

  const handleClick = (master) => {
    toggleExtensionCollapse();
    dispatch(toggleVideoVisible({ videoVisible: false }))
    if (Object.keys(userActivities[selectedUserActivity]).length < 4) {
      if(isVideo){
        dispatch(updateUserActivityVideo({ activity: master, selectedActivityIdx: selectedUserActivity }));
      }else{
        dispatch(updateUserActivity({ activity: master, selectedActivityIdx: selectedUserActivity }));
      }
    } else {
      if(isVideo){
        console.log('curr', userActivities[selectedUserActivity]);
        let timestamp =  userActivities[selectedUserActivity]?.question_id?.timestamp
        // return
        dispatch(toggleConfirmReplaceModal(true));
        dispatch(updateMasterToReplace({
          ...master,
          question_id: {
            ...master.question_id,
            timestamp
          }
        }));
      }else{
        dispatch(toggleConfirmReplaceModal(true));
        dispatch(updateMasterToReplace(master));

      }
    }
  };

  const handleLoadMoreClick = () => {
    const subtypeId = data[0].activity_subtype_id;
    dispatch(
      updateMegaSlider({
        active: true,
        activityTypeName,
        subtypeName,
        activityTypeId: activityTypeId,
        activitySubtypeId: subtypeId,
      })
    );
  };

  if (data === undefined) {
    return <></>;
  }

  return (
    <div className="sidebar_extension__slider__container">
      <p className="subtype_name"> {header} </p>

      <div style={{ alignItems: "center" }}>
        <Swiper
          className="sidebar_extension__slider"
          slidesPerView={2}
          spaceBetween={8}
          // mousewheel={true}
          slidesPerGroup={1}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          modules={[Navigation, Mousewheel]}
        >
          {data.map((master, idx) => {
            let imgSrc = null
            // if(master?.duonut_id?.duonutthumbnail_set){
            //   if(master?.duonut_id?.duonutthumbnail_set[0] !== undefined){
            //     if(master?.duonut_id?.duonutthumbnail_set[0].thumbnail){
            //       imgSrc = master?.duonut_id?.duonutthumbnail_set[0].thumbnail
            //     }
            //   }
            // }
            if(imgSrc === null){
              imgSrc = master.theme_id.thumbnail
            }
            return (
              <>
                {/* {console.log(master.id)} */}
                <SwiperSlide key={master.id} onClick={() => handleClick(master)}>
                  <div className="sidebar_extension__slider__img_container">
                    <img
                      className="skeleton"
                      onLoad={(e) => e.target.classList.remove("skeleton")}
                      src={imgSrc ? imgSrc : "/assets/theme.png"}
                      style={{ maxWidth: "200px", maxHeight: "102px", objectFit: "cover", borderRadius: "inherit" }}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                {idx + 1 === data.length && isLoadMoreVisible && (
                  <SwiperSlide key={master.id *787}>
                    <button className="load-more-btn" onClick={handleLoadMoreClick}>
                      {" "}
                      Load more{" "}
                    </button>
                  </SwiperSlide>
                )}
              </>
            );
          })}
          <div ref={navigationPrevRef} className="swiper__navigation_icon left">
            <img src="/assets/icons/left-icon.svg" style={{ cursor: "pointer" }} />
          </div>
          <div ref={navigationNextRef} className="swiper__navigation_icon right">
            <img src="/assets/icons/right-icon.svg" style={{ cursor: "pointer" }} />
          </div>
        </Swiper>
      </div>
    </div>
  );
}
